/** Shared background music for hub menus (welcome, strategy, command-center, etc.). */
export const MAIN_MENU_MUSIC_PATH = '/music/main_theme.mp3';
